import { Injectable } from "@angular/core"
import { BehaviorSubject } from "rxjs"
import { BusinessPorting } from "../meta/BusinessPorting.interface"
import { INITIAL_BUSINESS_PORTING } from "../meta/initial-business-porting.const"

@Injectable({
  providedIn: "root"
})
export class BusinessPortingService {
  private readonly _businessPorting$ = new BehaviorSubject<BusinessPorting>(INITIAL_BUSINESS_PORTING)
  public readonly businessPorting$ = this._businessPorting$.asObservable()

  public getBusinessPorting(): BusinessPorting {
    return this._businessPorting$.getValue()
  }

  public setBusinessPorting(businessPorting: Partial<BusinessPorting>): void {
    this._businessPorting$.next({
      ...this._businessPorting$.getValue(),
      ...businessPorting
    })
  }

  public getNumber(index: number): string {
    const numbers = this._businessPorting$.getValue().numbers
    if (numbers.length > index) {
      return numbers[index - 1]
    }
    return ""
  }

  public setNumber(index: number, number: string): void {
    const numbers = [...this._businessPorting$.getValue().numbers]
    numbers.splice(index - 1, 1, number)
    this.setBusinessPorting({
      numbers
    })
  }
}
